import { z } from 'zod';

export const LoginSchema = z.object({
  email: z
    .string()
    .nonempty('Email is required')
    .email('Enter a valid email address'),
  password: z
    .string()
    .min(2, 'Password must be at least 8 characters')
});

// default form values
export const loginDefaults = {
  email: '',
  password: '',
};